// 


import React, { useState } from "react";
import PropTypes from "prop-types";
import * as Icons from "react-bootstrap-icons";
import IconPickerModal from "./IconPickerModal";

const FormIconSelect = ({
    field,
    value,
    handleChange,
    error,
}) => {
    const [showModal, setShowModal] = useState(false);

    const SelectedIcon =
        value && Icons[value]
            ? Icons[value]
            : null;

    const handleSelect = (iconName) => {
        handleChange({
            target: {
                name: field.name,
                value: iconName,
            },
        });
    };

    return (
        <div className={field.fieldSize || "col-12"}>
            {!field.lableHide && (
                <label className="form-label text-muted">
                    {field.label}
                    {field.required && (
                        <span className="text-danger"> *</span>
                    )}
                </label>
            )}

            <div
                className={`form-control d-flex align-items-center justify-content-between ${
                    error ? "border-danger" : ""
                }`}
                style={{
                    cursor: "pointer",
                    height: "38px",
                }}
                onClick={() => setShowModal(true)}
            >
                <div className="d-flex align-items-center gap-2">
                    {SelectedIcon && (
                        <SelectedIcon size={18} />
                    )}

                    <span>
                        {value || field.placeholder || "Select Icon"}
                    </span>
                </div>

                <i className="bi bi-search"></i>
            </div>

            {error && (
                <span className="text-danger">
                    {error}
                </span>
            )}

            <IconPickerModal
                show={showModal}
                onHide={() => setShowModal(false)}
                onSelect={handleSelect}
            />
        </div>
    );
};

FormIconSelect.propTypes = {
    field: PropTypes.object.isRequired,
    value: PropTypes.string,
    handleChange: PropTypes.func.isRequired,
    error: PropTypes.string,
};

export default FormIconSelect;